import { ChangeEvent } from 'react';
import Select from 'react-select';
import { CustomStyle } from '../../../../../components/CustomSelectStyle';
import FormGroup from '../../../../../components/FormGroup';
import Input from '../../../../../components/Input';
import { GetErrorMessageByFieldNameType } from '../../../../../hooks/useErrors';
import { AsideContainer, Container, Group } from '../styles';
import { UserTypeType } from '../types';

interface IGeneralDataCard {
  getErrorMessageByFieldName: GetErrorMessageByFieldNameType;
  name: string;
  cpf: string;
  email: string;
  type: UserTypeType;
  handleNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleCpfChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleEmailChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleTypeChange: (profile: { value: number, label: string }) => void;
  isTypeSelectDisabled: boolean;
  typeOptions: { value: number, label: string }[];
  edit: boolean;
}

export default function GeneralDataCard({
  getErrorMessageByFieldName,
  name,
  cpf,
  email,
  type,
  handleNameChange,
  handleCpfChange,
  handleEmailChange,
  handleTypeChange,
  typeOptions,
  isTypeSelectDisabled,
  edit,
}: IGeneralDataCard) {
  return (
    <Container>
      <div className="card-title">
        Dados Gerais
      </div>
      <AsideContainer>
        <Group>
          <div className="title">
            CPF *
          </div>
          <FormGroup error={getErrorMessageByFieldName('cpf')}>
            <Input
              value={cpf}
              onChange={handleCpfChange}
              error={getErrorMessageByFieldName('cpf')}
              placeholder="Informe o CPF"
              maxLength={14}
              disabled={edit}
            />
          </FormGroup>
        </Group>
        <Group>
          <div className="title">
            Nome completo *
          </div>
          <FormGroup error={getErrorMessageByFieldName('name')}>
            <Input
              value={name}
              onChange={handleNameChange}
              error={getErrorMessageByFieldName('name')}
              placeholder="Informe nome e sobrenome"
              maxLength={25}
            />
          </FormGroup>
        </Group>
      </AsideContainer>
      <AsideContainer>
        <Group>
          <div className="title">
            E-mail *
          </div>
          <FormGroup error={getErrorMessageByFieldName('email')}>
            <Input
              value={email}
              onChange={handleEmailChange}
              error={getErrorMessageByFieldName('email')}
              placeholder="Informe o e-mail"
              maxLength={50}
            />
          </FormGroup>
        </Group>
        <Group>
          <div className="title">
            Perfil *
          </div>
          <Select
            value={{ value: type?.value, label: type?.label }}
            options={typeOptions}
            onChange={(opt) => {
              handleTypeChange({ value: opt!.value, label: opt!.label });
            }}
            styles={CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container"
            isDisabled={isTypeSelectDisabled}
          />
        </Group>
      </AsideContainer>
    </Container>
  );
}
